import Vue from 'vue';
import Vuex from 'vuex';
import requireContext from '@/utils/require-context';
import userModulePlugins from './modules/vuser/vuser-plugins';

Vue.use(Vuex);

const storeModules = {};

// Import all of the module files.
function loadModules() {
	let context;

	if (process.env.NODE_ENV === 'test') {
		//when running jest, there's no webpack require
		context = requireContext('../', true, /.*-module\.js$/i);
	} else {
		context = require.context(
			process.env.VUE_APP_MODULE_BASE,
			true,
			/.*-module\.js$/i
		);
	}

	return context
		.keys()
		.map(context) // import module
		.map(m => {
			if (m.default) {
				return m.default;
			} else {
				//for the rollup build requireContext plugin
				return m;
			}
		}); // get `default` export from each resolved module
}

let modules = [];

// if (process.env.NODE_ENV !== 'pckg') {
modules = loadModules();
// }

modules.forEach(module => {
	if (module != undefined) {
		storeModules[module.name] = module;
	}
});

export default new Vuex.Store({
	strict:
		process.env.NODE_ENV !== 'production' ||
		process.env.NODE_ENV !== 'pckg',
	modules: storeModules,
	plugins: userModulePlugins
});
